import { jsx as e } from "react/jsx-runtime";
import { c as i } from "../../index-Cu0xwYjD.js";
import { ContainerCssClass as s } from "./Container.types.js";
const l = ({
  children: o,
  className: r,
  fluid: a,
  ...m
}) => /* @__PURE__ */ e(
  "div",
  {
    ...m,
    className: i(r, s.Base, {
      [s.Fluid]: a
    }),
    children: o
  }
);
export {
  l as IressContainer
};
